import { render, staticRenderFns } from "./DiscussionForumList.vue?vue&type=template&id=c588e08c&scoped=true&"
import script from "./DiscussionForumList.vue?vue&type=script&lang=js&"
export * from "./DiscussionForumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c588e08c",
  null
  
)

export default component.exports